import * as React from 'react';

interface IPanelProps extends React.PropsWithChildren {
	type?: 'default' | 'success' | 'warn' | 'error' | 'toolbar' | 'tada';
	withIcon?: boolean;
	className?: string;
}

export const Panel: React.FC<IPanelProps> = ({ type, children, withIcon, className }) => {
	const panelType = type || 'default';
	if (!withIcon) {
		return <div className={`panel panel--${panelType} ${className || ''}`}>{children}</div>;
	} else {
		return <div className={`panel panel--${panelType} panel--with-icon ${className || ''}`}>
			<img src={`/71eb904/assets/icons/messages/${panelType}.svg`}></img>
			<div className="panel--with-icon_text">{children}</div>
		</div>;
	}

};
